/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeSensitivecontentBannerData } from './moe-sensitivecontent-banner.data';
import { IMoeSensitivecontentBannerProps } from './moe-sensitivecontent-banner.props.autogenerated';

export interface IMoeSensitivecontentBannerViewProps extends IMoeSensitivecontentBannerProps<IMoeSensitivecontentBannerData> {}

/**
 *
 * MoeSensitivecontentBanner component
 * @extends {React.PureComponent<IMoeSensitivecontentBannerProps<IMoeSensitivecontentBannerData>>}
 */
class MoeSensitivecontentBanner extends React.PureComponent<IMoeSensitivecontentBannerProps<IMoeSensitivecontentBannerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeSensitivecontentBanner;
